import React from "react";
import {Image} from "react-bootstrap";
import alertIcon from "../../asset/icons/alertIcon.svg"

const AlertBox = () => {
  return (
    <span className="alert_box">
      <Image src={alertIcon} className="image"/>
    </span>
  );
};

export default AlertBox;
